import { z } from "zod";
export const DocumentationPageApprovalState = z.enum([
    "ReadyForReview",
    "ChangesRequested",
    "Approved",
]);
